/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "1.2.0",
  "gitBuildTime": "2026-03-25T17:47:03.401Z",
  "gitBuildVersion": "1.2.0",
  "gitCommitId": "e618939",
  "gitCommitIdFull": "e618939a0ec3c6fcbe5bc3d0f7499b0b63742462",
  "gitCommitTime": "2026-03-25T17:45:53.000Z",
  "version": "1.2.0-2026-03-25T17:45:53.000Z-(e618939)"
};
